/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import {
  DataConnectionSelectItemSchemaFragmentDoc,
  DataConnectionSelectItemFragmentDoc,
} from "../../../data/selector/DataConnectionSelectItemRenderer.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SqlCellSchemaFragment = {
  readonly __typename: "DataConnectionSchema";
  readonly connectionType: c.DataConnectionType;
  readonly connectionMetadata: {
    readonly __typename: "DataConnectionMetadata";
    readonly displayName: string;
    readonly monacoLanguage: string;
    readonly multiDatabase: boolean;
  };
};

export type SqlCellDataConnectionFragment = {
  readonly __typename: "DataConnection";
  readonly id: c.DataConnectionId;
  readonly connectionName: string;
  readonly connectionType: c.DataConnectionType;
  readonly hasDetails: boolean;
  readonly magicUsageStatus: Types.MagicUsageStatus;
  readonly connectionDescription: string | null;
  readonly hexId: c.HexId | null;
  readonly isDemoConnection: boolean;
  readonly demoDataConnectionId: c.DemoDataConnectionId | null;
  readonly allowWriteback: boolean;
  readonly enableSnowpark: boolean;
  readonly authenticationType: string | null;
  readonly isDefault: boolean;
  readonly isMultiDatabase: boolean;
  readonly dbtSemanticLayerVersion: Types.DbtSemanticLayerVersion | null;
  readonly hasDbtMetrics: boolean;
  readonly hasDbtProxy: boolean;
  readonly hasDbtMetadata: boolean;
  readonly lastRefreshed: c.DateTimeString | null;
  readonly dbtErrorMessages: ReadonlyArray<string> | null;
  readonly dbtMetadataError: boolean;
  readonly dbtMetadataErrorMessages: ReadonlyArray<string> | null;
  readonly dbtMetricsError: boolean;
  readonly dbtMetricsErrorMessages: ReadonlyArray<string> | null;
  readonly schemaRefreshErrorMessages: ReadonlyArray<string> | null;
  readonly useDbtJdbcDriver: boolean | null;
  readonly status: string | null;
  readonly hasEndorsedTables: boolean;
  readonly oauthSettings: {
    readonly __typename: "DataConnectionOAuthSettings";
    readonly id: c.DataConnectionOAuthSettingsId;
    readonly logicViewSetting: Types.OAuthLogicViewSetting;
    readonly publishedAppSetting: Types.OAuthPublishedAppSetting;
  } | null;
  readonly passthroughOAuthInfo: {
    readonly __typename: "PassthroughOAuthInfo";
    readonly dataConnectionId: c.DataConnectionId;
    readonly dataConnectionType: c.OAuthConnectionType;
    readonly oAuthConnectionId: string;
    readonly hasValidToken: boolean;
    readonly currentRole: string | null;
    readonly requiredRole: string | null;
    readonly authWithSso: boolean;
  } | null;
  readonly grants: ReadonlyArray<{
    readonly __typename: "SharedAssetGrant";
    readonly id: c.SharedAssetGrantId;
    readonly role: Types.SharedAssetRole;
    readonly holder:
      | { readonly __typename: "Group"; readonly groupId: c.GroupId }
      | {
          readonly __typename: "IntrinsicGroup";
          readonly name: string;
          readonly intrinsicGroupId: Types.IntrinsicGroupId;
        };
  }>;
};

export type GetSharedProjectDataConnectionsForSqlCellQueryVariables =
  Types.Exact<{
    hexVersionId: Types.Scalars["HexVersionId"]["input"];
    appSessionId?: Types.InputMaybe<Types.Scalars["AppSessionId"]["input"]>;
  }>;

export type GetSharedProjectDataConnectionsForSqlCellQuery = {
  readonly __typename: "Query";
  readonly sharedProjectDataConnections: ReadonlyArray<{
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly connectionName: string;
    readonly connectionType: c.DataConnectionType;
    readonly hasDetails: boolean;
    readonly magicUsageStatus: Types.MagicUsageStatus;
    readonly connectionDescription: string | null;
    readonly hexId: c.HexId | null;
    readonly isDemoConnection: boolean;
    readonly demoDataConnectionId: c.DemoDataConnectionId | null;
    readonly allowWriteback: boolean;
    readonly enableSnowpark: boolean;
    readonly authenticationType: string | null;
    readonly isDefault: boolean;
    readonly isMultiDatabase: boolean;
    readonly dbtSemanticLayerVersion: Types.DbtSemanticLayerVersion | null;
    readonly hasDbtMetrics: boolean;
    readonly hasDbtProxy: boolean;
    readonly hasDbtMetadata: boolean;
    readonly lastRefreshed: c.DateTimeString | null;
    readonly dbtErrorMessages: ReadonlyArray<string> | null;
    readonly dbtMetadataError: boolean;
    readonly dbtMetadataErrorMessages: ReadonlyArray<string> | null;
    readonly dbtMetricsError: boolean;
    readonly dbtMetricsErrorMessages: ReadonlyArray<string> | null;
    readonly schemaRefreshErrorMessages: ReadonlyArray<string> | null;
    readonly useDbtJdbcDriver: boolean | null;
    readonly status: string | null;
    readonly hasEndorsedTables: boolean;
    readonly oauthSettings: {
      readonly __typename: "DataConnectionOAuthSettings";
      readonly id: c.DataConnectionOAuthSettingsId;
      readonly logicViewSetting: Types.OAuthLogicViewSetting;
      readonly publishedAppSetting: Types.OAuthPublishedAppSetting;
    } | null;
    readonly passthroughOAuthInfo: {
      readonly __typename: "PassthroughOAuthInfo";
      readonly dataConnectionId: c.DataConnectionId;
      readonly dataConnectionType: c.OAuthConnectionType;
      readonly oAuthConnectionId: string;
      readonly hasValidToken: boolean;
      readonly currentRole: string | null;
      readonly requiredRole: string | null;
      readonly authWithSso: boolean;
    } | null;
    readonly grants: ReadonlyArray<{
      readonly __typename: "SharedAssetGrant";
      readonly id: c.SharedAssetGrantId;
      readonly role: Types.SharedAssetRole;
      readonly holder:
        | { readonly __typename: "Group"; readonly groupId: c.GroupId }
        | {
            readonly __typename: "IntrinsicGroup";
            readonly name: string;
            readonly intrinsicGroupId: Types.IntrinsicGroupId;
          };
    }>;
  }>;
};

export type GetOrgDataConnectionsForSqlCellQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
  appSessionId: Types.InputMaybe<Types.Scalars["AppSessionId"]["input"]>;
}>;

export type GetOrgDataConnectionsForSqlCellQuery = {
  readonly __typename: "Query";
  readonly orgDataConnections: ReadonlyArray<{
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly connectionName: string;
    readonly connectionType: c.DataConnectionType;
    readonly hasDetails: boolean;
    readonly magicUsageStatus: Types.MagicUsageStatus;
    readonly connectionDescription: string | null;
    readonly hexId: c.HexId | null;
    readonly isDemoConnection: boolean;
    readonly demoDataConnectionId: c.DemoDataConnectionId | null;
    readonly allowWriteback: boolean;
    readonly enableSnowpark: boolean;
    readonly authenticationType: string | null;
    readonly isDefault: boolean;
    readonly isMultiDatabase: boolean;
    readonly dbtSemanticLayerVersion: Types.DbtSemanticLayerVersion | null;
    readonly hasDbtMetrics: boolean;
    readonly hasDbtProxy: boolean;
    readonly hasDbtMetadata: boolean;
    readonly lastRefreshed: c.DateTimeString | null;
    readonly dbtErrorMessages: ReadonlyArray<string> | null;
    readonly dbtMetadataError: boolean;
    readonly dbtMetadataErrorMessages: ReadonlyArray<string> | null;
    readonly dbtMetricsError: boolean;
    readonly dbtMetricsErrorMessages: ReadonlyArray<string> | null;
    readonly schemaRefreshErrorMessages: ReadonlyArray<string> | null;
    readonly useDbtJdbcDriver: boolean | null;
    readonly status: string | null;
    readonly hasEndorsedTables: boolean;
    readonly oauthSettings: {
      readonly __typename: "DataConnectionOAuthSettings";
      readonly id: c.DataConnectionOAuthSettingsId;
      readonly logicViewSetting: Types.OAuthLogicViewSetting;
      readonly publishedAppSetting: Types.OAuthPublishedAppSetting;
    } | null;
    readonly passthroughOAuthInfo: {
      readonly __typename: "PassthroughOAuthInfo";
      readonly dataConnectionId: c.DataConnectionId;
      readonly dataConnectionType: c.OAuthConnectionType;
      readonly oAuthConnectionId: string;
      readonly hasValidToken: boolean;
      readonly currentRole: string | null;
      readonly requiredRole: string | null;
      readonly authWithSso: boolean;
    } | null;
    readonly grants: ReadonlyArray<{
      readonly __typename: "SharedAssetGrant";
      readonly id: c.SharedAssetGrantId;
      readonly role: Types.SharedAssetRole;
      readonly holder:
        | { readonly __typename: "Group"; readonly groupId: c.GroupId }
        | {
            readonly __typename: "IntrinsicGroup";
            readonly name: string;
            readonly intrinsicGroupId: Types.IntrinsicGroupId;
          };
    }>;
  }>;
};

export type GetSchemasForSqlCellQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetSchemasForSqlCellQuery = {
  readonly __typename: "Query";
  readonly dataConnectionSchemas: ReadonlyArray<{
    readonly __typename: "DataConnectionSchema";
    readonly connectionType: c.DataConnectionType;
    readonly connectionMetadata: {
      readonly __typename: "DataConnectionMetadata";
      readonly displayName: string;
      readonly monacoLanguage: string;
      readonly multiDatabase: boolean;
    };
  }>;
};

export const SqlCellSchemaFragmentDoc = /*#__PURE__*/ gql`
  fragment SqlCellSchemaFragment on DataConnectionSchema {
    connectionType
    connectionMetadata {
      displayName
      monacoLanguage
      multiDatabase
    }
    ...DataConnectionSelectItemSchemaFragment
  }
  ${DataConnectionSelectItemSchemaFragmentDoc}
`;
export const SqlCellDataConnectionFragmentDoc = /*#__PURE__*/ gql`
  fragment SqlCellDataConnectionFragment on DataConnection {
    id
    connectionName
    connectionType
    hasDetails
    magicUsageStatus
    ...DataConnectionSelectItemFragment
  }
  ${DataConnectionSelectItemFragmentDoc}
`;
export const GetSharedProjectDataConnectionsForSqlCellDocument = /*#__PURE__*/ gql`
  query GetSharedProjectDataConnectionsForSqlCell(
    $hexVersionId: HexVersionId!
    $appSessionId: AppSessionId = null
  ) {
    sharedProjectDataConnections(hexVersionId: $hexVersionId) {
      ...SqlCellDataConnectionFragment
    }
  }
  ${SqlCellDataConnectionFragmentDoc}
`;

/**
 * __useGetSharedProjectDataConnectionsForSqlCellQuery__
 *
 * To run a query within a React component, call `useGetSharedProjectDataConnectionsForSqlCellQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedProjectDataConnectionsForSqlCellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedProjectDataConnectionsForSqlCellQuery({
 *   variables: {
 *      hexVersionId: // value for 'hexVersionId'
 *      appSessionId: // value for 'appSessionId'
 *   },
 * });
 */
export function useGetSharedProjectDataConnectionsForSqlCellQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSharedProjectDataConnectionsForSqlCellQuery,
    GetSharedProjectDataConnectionsForSqlCellQueryVariables
  > &
    (
      | {
          variables: GetSharedProjectDataConnectionsForSqlCellQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSharedProjectDataConnectionsForSqlCellQuery,
    GetSharedProjectDataConnectionsForSqlCellQueryVariables
  >(GetSharedProjectDataConnectionsForSqlCellDocument, options);
}
export function useGetSharedProjectDataConnectionsForSqlCellLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSharedProjectDataConnectionsForSqlCellQuery,
    GetSharedProjectDataConnectionsForSqlCellQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSharedProjectDataConnectionsForSqlCellQuery,
    GetSharedProjectDataConnectionsForSqlCellQueryVariables
  >(GetSharedProjectDataConnectionsForSqlCellDocument, options);
}
export function useGetSharedProjectDataConnectionsForSqlCellSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSharedProjectDataConnectionsForSqlCellQuery,
    GetSharedProjectDataConnectionsForSqlCellQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSharedProjectDataConnectionsForSqlCellQuery,
    GetSharedProjectDataConnectionsForSqlCellQueryVariables
  >(GetSharedProjectDataConnectionsForSqlCellDocument, options);
}
export type GetSharedProjectDataConnectionsForSqlCellQueryHookResult =
  ReturnType<typeof useGetSharedProjectDataConnectionsForSqlCellQuery>;
export type GetSharedProjectDataConnectionsForSqlCellLazyQueryHookResult =
  ReturnType<typeof useGetSharedProjectDataConnectionsForSqlCellLazyQuery>;
export type GetSharedProjectDataConnectionsForSqlCellSuspenseQueryHookResult =
  ReturnType<typeof useGetSharedProjectDataConnectionsForSqlCellSuspenseQuery>;
export type GetSharedProjectDataConnectionsForSqlCellQueryResult =
  Apollo.QueryResult<
    GetSharedProjectDataConnectionsForSqlCellQuery,
    GetSharedProjectDataConnectionsForSqlCellQueryVariables
  >;
export const GetOrgDataConnectionsForSqlCellDocument = /*#__PURE__*/ gql`
  query GetOrgDataConnectionsForSqlCell(
    $orgId: OrgId!
    $appSessionId: AppSessionId
  ) {
    orgDataConnections(orgId: $orgId, importable: true) {
      ...SqlCellDataConnectionFragment
    }
  }
  ${SqlCellDataConnectionFragmentDoc}
`;

/**
 * __useGetOrgDataConnectionsForSqlCellQuery__
 *
 * To run a query within a React component, call `useGetOrgDataConnectionsForSqlCellQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgDataConnectionsForSqlCellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgDataConnectionsForSqlCellQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      appSessionId: // value for 'appSessionId'
 *   },
 * });
 */
export function useGetOrgDataConnectionsForSqlCellQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrgDataConnectionsForSqlCellQuery,
    GetOrgDataConnectionsForSqlCellQueryVariables
  > &
    (
      | {
          variables: GetOrgDataConnectionsForSqlCellQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrgDataConnectionsForSqlCellQuery,
    GetOrgDataConnectionsForSqlCellQueryVariables
  >(GetOrgDataConnectionsForSqlCellDocument, options);
}
export function useGetOrgDataConnectionsForSqlCellLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrgDataConnectionsForSqlCellQuery,
    GetOrgDataConnectionsForSqlCellQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrgDataConnectionsForSqlCellQuery,
    GetOrgDataConnectionsForSqlCellQueryVariables
  >(GetOrgDataConnectionsForSqlCellDocument, options);
}
export function useGetOrgDataConnectionsForSqlCellSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrgDataConnectionsForSqlCellQuery,
    GetOrgDataConnectionsForSqlCellQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrgDataConnectionsForSqlCellQuery,
    GetOrgDataConnectionsForSqlCellQueryVariables
  >(GetOrgDataConnectionsForSqlCellDocument, options);
}
export type GetOrgDataConnectionsForSqlCellQueryHookResult = ReturnType<
  typeof useGetOrgDataConnectionsForSqlCellQuery
>;
export type GetOrgDataConnectionsForSqlCellLazyQueryHookResult = ReturnType<
  typeof useGetOrgDataConnectionsForSqlCellLazyQuery
>;
export type GetOrgDataConnectionsForSqlCellSuspenseQueryHookResult = ReturnType<
  typeof useGetOrgDataConnectionsForSqlCellSuspenseQuery
>;
export type GetOrgDataConnectionsForSqlCellQueryResult = Apollo.QueryResult<
  GetOrgDataConnectionsForSqlCellQuery,
  GetOrgDataConnectionsForSqlCellQueryVariables
>;
export const GetSchemasForSqlCellDocument = /*#__PURE__*/ gql`
  query GetSchemasForSqlCell {
    dataConnectionSchemas {
      ...SqlCellSchemaFragment
    }
  }
  ${SqlCellSchemaFragmentDoc}
`;

/**
 * __useGetSchemasForSqlCellQuery__
 *
 * To run a query within a React component, call `useGetSchemasForSqlCellQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchemasForSqlCellQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchemasForSqlCellQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSchemasForSqlCellQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSchemasForSqlCellQuery,
    GetSchemasForSqlCellQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSchemasForSqlCellQuery,
    GetSchemasForSqlCellQueryVariables
  >(GetSchemasForSqlCellDocument, options);
}
export function useGetSchemasForSqlCellLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSchemasForSqlCellQuery,
    GetSchemasForSqlCellQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSchemasForSqlCellQuery,
    GetSchemasForSqlCellQueryVariables
  >(GetSchemasForSqlCellDocument, options);
}
export function useGetSchemasForSqlCellSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSchemasForSqlCellQuery,
    GetSchemasForSqlCellQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSchemasForSqlCellQuery,
    GetSchemasForSqlCellQueryVariables
  >(GetSchemasForSqlCellDocument, options);
}
export type GetSchemasForSqlCellQueryHookResult = ReturnType<
  typeof useGetSchemasForSqlCellQuery
>;
export type GetSchemasForSqlCellLazyQueryHookResult = ReturnType<
  typeof useGetSchemasForSqlCellLazyQuery
>;
export type GetSchemasForSqlCellSuspenseQueryHookResult = ReturnType<
  typeof useGetSchemasForSqlCellSuspenseQuery
>;
export type GetSchemasForSqlCellQueryResult = Apollo.QueryResult<
  GetSchemasForSqlCellQuery,
  GetSchemasForSqlCellQueryVariables
>;
